<template>
    <Module
        type="container"
        :resource="moduleContainer"
        :pointer-events="false"
        v-if="moduleContainer"
        :class="classes"
    />
</template>

<script>
import {inject} from "vue";
import {accessesData, hasEvents} from "@/services/data-layer/composers";
import Kernel from "@oilstone/kernel";

export default {
    setup(props) {
        const {id} = accessesData();
        const {listen} = hasEvents();
        const resource = Kernel.resolve('resourceRegistry').find(inject('type'));
        const pivotConfig = resource.config.relations.modules.pivot;
        const pivot = Kernel.resolve('resourceRegistry').find(pivotConfig.type);

        const findPivot = () => {
            return pivot.repository
                .baseQuery()
                .include('modules.modules')
                .where(pivotConfig.localKey, id.value)
                .where('modules.location', props.location)
                .first();
        };

        return {
            findPivot,
            listen
        }
    },

    props: {
        location: {
            type: String,
            default: 'default'
        }
    },

    data() {
        return {
            moduleContainer: null,
        }
    },

    computed: {
        classes() {
            return [`module-container--${this.location}`];
        }
    },

    mounted() {
        this.findPivot().then(record => {
            if (record) {
                const container = record.modules;

                container.modules = container.modules.sort((a, b) => {
                    if (a.sort < b.sort) {
                        return -1;
                    }

                    if (a.sort > b.sort) {
                        return 1;
                    }

                    return 0;
                })

                this.moduleContainer = container;
            }
        });
    }
}
</script>
